import React from 'react'
import DatePickerRJS from 'react-datepicker'

import { useStyles } from './datePicker.css'
import { toUtcDate } from 'utils/dateUtilities'

const DatePicker = (props) => {
  const { onChange } = props
  const classes = useStyles()
  const handleChange = React.useCallback(x => onChange(toUtcDate(x)), [onChange])
  return (
    <DatePickerRJS
      className={`form-control ${classes.root}`}
      selected={props.value}
      onChange={handleChange}
      disabled={props.disabled}
      isClearable={!props.disabled}
      dateFormat='dd.MM.yyyy'
    />
  )
}

export {
  DatePicker
}
